/**
 * Audio Trader Theme JavaScript
 * ⛔ DRAFT THEME - DO NOT PUBLISH TO LIVE
 */

(function() {
  'use strict';

  // Mobile menu functionality is inline in at-header.liquid

  // Product image gallery switching is inline in main-product.liquid

  // ---- Product card: AJAX add to cart ----
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.at-pcard__add');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    var label = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () {
        btn.innerHTML = 'Try again';
        setTimeout(function () { btn.innerHTML = label; btn.disabled = false; }, 1800);
      });
  });

  // ---- Sold card: notify-me-when-relisted (capture endpoint lands in Phase D) ----
  var NOTIFY_ENDPOINT = 'https://prism-commerce.com/api/marketing/notify-me';
  var notifyModal = null;
  function buildNotifyModal() {
    var wrap = document.createElement('div');
    wrap.className = 'at-notify-modal';
    wrap.hidden = true;
    wrap.innerHTML =
      '<div class="at-notify-modal__overlay" data-notify-close></div>' +
      '<div class="at-notify-modal__panel" role="dialog" aria-modal="true" aria-label="Notify me if relisted">' +
        '<button type="button" class="at-notify-modal__x" data-notify-close aria-label="Close">&times;</button>' +
        '<h3 class="at-notify-modal__title">Notify me if relisted</h3>' +
        '<p class="at-notify-modal__sub" data-notify-product></p>' +
        '<form class="at-notify-modal__form">' +
          '<input type="text" name="name" placeholder="Your name (optional)" class="at-input">' +
          '<input type="email" name="email" placeholder="Email address" class="at-input" required>' +
          '<button type="submit" class="at-btn at-btn-primary" style="width:100%;">Notify me</button>' +
        '</form>' +
        '<p class="at-notify-modal__msg" hidden></p>' +
      '</div>';
    document.body.appendChild(wrap);
    wrap.addEventListener('click', function (e) { if (e.target.hasAttribute('data-notify-close')) closeNotify(); });
    wrap.querySelector('form').addEventListener('submit', submitNotify);
    return wrap;
  }
  var notifyCtx = {};
  function openNotify(data) {
    notifyCtx = data;
    if (!notifyModal) notifyModal = buildNotifyModal();
    notifyModal.querySelector('[data-notify-product]').textContent = 'We will email you if "' + data.title + '" comes back in stock.';
    var f = notifyModal.querySelector('form'); f.hidden = false; f.reset();
    var msg = notifyModal.querySelector('.at-notify-modal__msg'); msg.hidden = true;
    notifyModal.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeNotify() { if (notifyModal) { notifyModal.hidden = true; document.body.style.overflow = ''; } }
  function submitNotify(e) {
    e.preventDefault();
    var f = e.target;
    var msg = notifyModal.querySelector('.at-notify-modal__msg');
    var payload = {
      email: f.email.value, name: f.name.value,
      shopify_product_id: notifyCtx.id, product_title: notifyCtx.title,
      price: notifyCtx.price, source: 'storefront-sold-card'
    };
    var submitBtn = f.querySelector('button[type=submit]'); submitBtn.disabled = true;
    fetch(NOTIFY_ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { if (!r.ok) throw new Error('notify'); return r.json(); })
      .then(function () { f.hidden = true; msg.hidden = false; msg.textContent = 'Thanks - we will be in touch if it returns.'; })
      .catch(function () { msg.hidden = false; msg.textContent = 'Sorry, something went wrong. Please try again later.'; submitBtn.disabled = false; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.at-pcard__notify');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    openNotify({ id: b.getAttribute('data-product-id'), title: b.getAttribute('data-product-title'), price: b.getAttribute('data-product-price') });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNotify(); });

  // ---- GA4: select_item when a product card is clicked ----
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.at-pcard__link, .at-mcard__link');
    if (!link || typeof gtag !== 'function') return;
    gtag('event', 'select_item', {
      item_list_id: window.AT_LIST_ID || '',
      item_list_name: window.AT_LIST_NAME || '',
      items: [{
        item_id: link.getAttribute('data-ga4-item-id'),
        item_name: link.getAttribute('data-product-title'),
        price: parseFloat(link.getAttribute('data-product-price')) / 100
      }]
    });
  });

  console.log('Audio Trader Theme loaded');
})();
